import { ThemeColorInterface } from './';

export const DarkRedTheme: ThemeColorInterface[] = [
    { key: '--rgb-main-background-color', value: '30, 30, 30' },
    { key: '--rgb-body-background-color', value: '30, 30, 30' },
    { key: '--rgb-header-background-color', value: '30, 30, 30' },
    { key: '--rgb-subheader-background-color', value: '30, 30, 30' },
    { key: '--rgb-dropdown-background-color', value: '125, 19, 23' },
    { key: '--rgb-icons', value: '115, 127, 146' },
    { key: '--rgb-primary-cta-color', value: '214, 32, 39' },
    { key: '--rgb-contrast-cta-color', value: '214, 32, 39' },
    { key: '--rgb-secondary-contrast-cta-color', value: '115, 127, 146' },
    { key: '--rgb-cta-layer-color', value: '30, 30, 30' },
    { key: '--rgb-system-green', value: '84, 180, 137' },
    { key: '--rgb-system-red', value: '232, 94, 89' },
    { key: '--rgb-system-yellow', value: '232, 175, 89' },
    { key: '--rgb-asks', value: '232, 94, 89' },
    { key: '--rgb-bids', value: '84, 180, 137' },
    { key: '--rgb-primary-text-color', value: '255, 255, 255' },
    { key: '--rgb-text-contrast-color', value: '23, 28, 41' },
    { key: '--rgb-input-background-color', value: '30, 40, 65' },
    { key: '--rgb-divider-color', value: '214, 32, 39' },
    { key: '--rgb-shadow-color', value: '214, 32, 39' },
    { key: '--rgb-landing-background-color', value: '251, 251, 251' },
    { key: '--rgb-strength-meter-very-strong', value: '108, 239, 239' },
];
